import React from 'react';
import { CModal } from '@web-kc/shared/ui';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'next-i18next';

import LotTypeFilter from './FilterComponents/lotType';
import { useFilters } from '../Provider';
import LotStatusesFilter from './FilterComponents/lotStatuses';
import LotCategoriesFilter from './FilterComponents/lotCategories';
import LotCompanies from './FilterComponents/lotCompanies';
import LotInitiator from './FilterComponents/lotInitiator';
import LotRegion from './FilterComponents/lotRegion';
import LotDates from './FilterComponents/lotDates';
import { useRouter } from 'next/router';
import { useApp } from '@web-kc/core/providers';

export type LotAndTenderSearchModalT = {
  open: boolean;
  onClose: () => void;
};

const LotAndTenderSearchModal = ({
  open,
  onClose,
}: LotAndTenderSearchModalT) => {
  const { t } = useTranslation('tenders');

  const isMp = useApp() === 'rti';
  const { pathname } = useRouter();
  const { resetFilters, setField, applyFilters } = useFilters();

  const handleReset = () => {
    resetFilters();
    applyFilters();
  };

  const handleSearch = () => {
    setField('page', 0);
    applyFilters();
    onClose();
  };

  const isCabinet = pathname.includes('/cabinet');
  return (
    <CModal
      open={open}
      onClose={onClose}
      modalTitle={t('tenders.modal.searchFilters')}
      footer={
        <>
          <Button variant="outlined" onClick={handleReset}>
            {t('tenders.modal.resetButton')}
          </Button>
          <Button variant="contained" color="secondary" onClick={handleSearch}>
            {t('tenders.modal.searchButton')}
          </Button>
        </>
      }
      maxWidth="md"
      fullWidth
    >
      <Stack direction="column">
        <LotTypeFilter />

        <LotStatusesFilter />

        <LotCategoriesFilter />

        {isMp && !isCabinet && <LotCompanies />}

        {isCabinet && <LotInitiator />}

        <LotRegion />

        <LotDates />
      </Stack>
    </CModal>
  );
};

export default LotAndTenderSearchModal;
